import React from 'react';

import {
  Actions as UIActions,
  Action,
  SyncIcon,
  ShareIcon,
  DriveFileRenameOutlineIcon,
} from '@gogame/components';
import Permissions from '@gogame/permissions';

import {
  ACTION_ARCHIVE,
  ACTION_RESTORE,
  ACTION_DELETE,
  ACTION_SYNC,
  ACTION_SHARE,
  ACTION_ADD_LOOKALIKE_AUDIENCES,
  ACTION_EDIT,
} from 'scenes/CustomAudiences/PartnerAudiences/constants';

const Actions = ({
  actions = [],
  onSync,
  onShare,
  onAddLookalikeAudiences,
  onArchive,
  onRestore,
  onDelete,
  onEdit,
  limit = 0,
}) => {
  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => {
        return (
          <UIActions limit={limit}>
            <Action
              label={'Sync'}
              icon={<SyncIcon />}
              disabled={!isActionAllowed(ACTION_SYNC)}
              onClick={onSync}
            />

            <Action
              label={'Share'}
              onClick={onShare}
              icon={<ShareIcon />}
              disabled={!isActionAllowed(ACTION_SHARE)}
            />

            <Action
              label={'Add Lookalike Audiences'}
              onClick={onAddLookalikeAudiences}
              disabled={!isActionAllowed(ACTION_ADD_LOOKALIKE_AUDIENCES)}
            />

            <Action
              label={'Edit'}
              disabled={!isActionAllowed(ACTION_EDIT)}
              onClick={onEdit}
              icon={<DriveFileRenameOutlineIcon />}
            />
            {isActionAllowed(ACTION_ARCHIVE) ? (
              <Action label={'Archive'} onClick={onArchive} />
            ) : null}

            {isActionAllowed(ACTION_RESTORE) ? (
              <Action label={'Restore'} onClick={onRestore} />
            ) : null}
            <Action
              label={'Delete'}
              disabled={!isActionAllowed(ACTION_DELETE)}
              onClick={onDelete}
            />
          </UIActions>
        );
      }}
    </Permissions>
  );
};

export default Actions;
